import styled from '@emotion/styled';
import { Box, Button, Container, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { AllImage, Paragraph } from '../styling/style';
import BackBottom from '../assets/partner-bottom.png';
import CopyIcon from '../assets/copy.png';
import OpenIcon from '../assets/openicon.png';
import ButtonIcon from '../assets/buttonicon.png';
import PartnerSmall from '../assets/partnersmallscreen.png'
import Heading from '../components/heading';
import AOS from "aos";
import "aos/dist/aos.css";

const Div = styled.div`
    background-image: url(${BackBottom});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    @media (max-width: 600px){
        background-image: url(${PartnerSmall});
    } 
` 
const FGrid = styled(Grid)`
    @media (max-width: 900px){
        border-bottom: 1px solid #707070;
    }
`
const BoxGrid = styled(Box)`
    display: flex;
    justify-content: space-between;
    padding: 10px 0px;
    @media (max-width: 450px){
        flex-direction: column;
    }
`
const P = styled(Paragraph)`
    color: #ffffff;
    font-family: poppins-regular;
    font-size: 15px;
    text-align: left;
    display: flex;
    align-items: center;
    @media (max-width: 600px){
        font-size: 12px;
    } 
`

const GButton = styled(Button)`
    background: linear-gradient( to top, #FE8D46, #EE5867 );
    color: #ffffff;
    text-transform: none;
    width: 100%;
    min-height: 70px;
    display: flex;
    justify-content: flex-start;
    margin: 30px 0px;
    font-family: poppins-semibold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    @media (max-width: 600px){
        font-size: 12px;
    } 
`
const ButtonImg = styled(AllImage)`
    position: absolute;
    right: 18px;
    bottom: 0;
    max-width: 90px;
    @media (max-width: 600px){
        right: 10px;
    } 
`
const Tokenomics = () => {
    useEffect(() => {
        AOS.init({
          duration: 800,
          offset: 200,
        });
      }, []);
    
      useEffect(() => {
        AOS.refresh();
      });
    return(
        <Div>
            <Container maxWidth = 'lg'>
            <Grid container sx={{marginTop: '10%', padding: '8% 0% 15%'}} data-aos="fade-up" data-aos-duration="1200">
                <Heading
                    title = 'Peachy Tokenomics'
                    ta = 'center'
                    p = '20px 15px 0px'
                    fs='30px'
                />  
                <Grid container>
                    <FGrid xs={12} md={6} p ={3}>
                        <BoxGrid>
                            <P>Contact Address</P>
                            <P>0Xxxxxxx00000000000000000 &nbsp; <AllImage maxw='15px' src={CopyIcon}/></P>
                        </BoxGrid>
                        <BoxGrid>
                            <P>Name</P>
                            <P>Peachy Trader</P>
                        </BoxGrid>
                        <BoxGrid>
                            <P>Symbol</P>
                            <P>PEACHY</P>
                        </BoxGrid>
                        <BoxGrid>
                            <P>Total Supply</P>
                            <P>TBA</P>
                        </BoxGrid>
                        <BoxGrid>
                            <P>tax</P>
                            <P>TBA</P>
                        </BoxGrid>
                            <P>Tax enables us to continuously support long-term holders and avoid quick pump and dumps, it will also be used for marketing and our copy trding strategy</P>
                    </FGrid>
                    <Grid xs={12} md={6} p={3}>
                        <BoxGrid>
                            <P>Token Explorer</P>
                            <P>Etherscan &nbsp;<AllImage maxw='10px' src={OpenIcon}/></P>
                        </BoxGrid>
                        <BoxGrid>
                            <P>Liquidity Locked</P>
                            <P>TBA &nbsp;<AllImage maxw='10px' src={OpenIcon}/></P>
                        </BoxGrid>
                        <BoxGrid>
                            <P>Contract Renounced</P>
                            <P>Etherscan </P>
                        </BoxGrid>
                            <P>Max TX/Wallet will be temporary at launch to prevent dumping.</P>
                            <GButton data-aos='fade-in' data-aos-duration="1500" variant = 'contained'>Read Whitepaper <ButtonImg maxw='80px' src={ButtonIcon}/></GButton>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    </Div>
    )
}

export default Tokenomics;